import cx from 'classnames';
import React from 'react';
import './Truncate.scss';

export interface Props {
  children: string;
  className?: string;
}
const Truncate = ({ children, className }: Props) => {
  return <div className={cx('TruncateContainer', className)}>{children}</div>;
};

export default Truncate;
